import script from "./ReadonlyTags.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReadonlyTags.vue?vue&type=script&lang=ts&setup=true"

import "./ReadonlyTags.vue?vue&type=style&index=0&id=2bea3765&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bea3765"]])

export default __exports__